import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import '@sick-davinci/basic-elements/lib/option/Option.js';
import '@sick-davinci/basic-elements/lib/option/OptionGroup.js';
import '@sick-davinci/basic-elements/lib/spinner/Spinner.js';
import '@sick-davinci/basic-elements/lib/icon/Icon.js';
import '@sick-davinci/basic-elements/lib/icon/IconRef.js';
import '@sick-davinci/basic-elements/lib/drop-down/DropDown.js';
import '@sick-davinci/basic-elements/lib/auto-suggest/AutoSuggest.js';
import '@sick-davinci/basic-elements/lib/balloon/Balloon.js';
import '@sick-davinci/basic-elements/lib/breadcrumb/Breadcrumb.js';
import '@sick-davinci/basic-elements/lib/breadcrumb/BreadcrumbItem.js';
import '@sick-davinci/basic-elements/lib/button/Button.js';
import '@sick-davinci/basic-elements/lib/callout/Callout.js';
import '@sick-davinci/basic-elements/lib/checkbox/Checkbox.js';
import '@sick-davinci/basic-elements/lib/collapse/Collapse.js';
import '@sick-davinci/basic-elements/lib/dnd-file-chooser/DnDFileChooser.js';
import '@sick-davinci/basic-elements/lib/file-chooser/FileChooser.js';
import '@sick-davinci/basic-elements/lib/slider/Slider.js';
import '@sick-davinci/basic-elements/lib/flexi-slider/FlexiSlider.js';
import '@sick-davinci/basic-elements/lib/flyout-menu/flyout-menu-item/FlyoutMenuItem.js';
import '@sick-davinci/basic-elements/lib/flyout-menu/FlyoutMenu.js';
import '@sick-davinci/basic-elements/lib/link/Link.js';
import '@sick-davinci/basic-elements/lib/multi-select/MultiSelect.js';
import '@sick-davinci/basic-elements/lib/number-input/NumberInput.js';
import '@sick-davinci/basic-elements/lib/numeric-field/NumericField.js';
import '@sick-davinci/basic-elements/lib/popup-list/PopupList.js';
import '@sick-davinci/basic-elements/lib/progress-line/ProgressLine.js';
import '@sick-davinci/basic-elements/lib/radio-button/RadioButton.js';
import '@sick-davinci/basic-elements/lib/range-slider/RangeSlider.js';
import '@sick-davinci/basic-elements/lib/search-field/SearchField.js';
import '@sick-davinci/basic-elements/lib/status-indicator/StatusIndicator.js';
import '@sick-davinci/basic-elements/lib/status-line/StatusLine.js';
import '@sick-davinci/basic-elements/lib/status-text/StatusText.js';
import '@sick-davinci/basic-elements/lib/tab/Tab.js';
import '@sick-davinci/basic-elements/lib/tab/Tabs.js';
import '@sick-davinci/basic-elements/lib/tag/Tag.js';
import '@sick-davinci/basic-elements/lib/tag-module/TagModule.js';
import '@sick-davinci/basic-elements/lib/text-area/TextArea.js';
import '@sick-davinci/basic-elements/lib/text-field/TextField.js';
import '@sick-davinci/basic-elements/lib/tile/Tile.js';
import '@sick-davinci/basic-elements/lib/toggle-group/ToggleGroup.js';
import '@sick-davinci/basic-elements/lib/toggle-switch/ToggleSwitch.js';
import '@sick-davinci/basic-elements/lib/value-display/ValueDisplay.js';

/* eslint-disable eslint-comments/no-unlimited-disable */
const proxyInputs = (Cmp, inputs) => {
    const Prototype = Cmp.prototype;
    inputs.forEach((item) => {
        Object.defineProperty(Prototype, item, {
            get() {
                return this.el[item];
            },
            set(val) {
                this.z.runOutsideAngular(() => (this.el[item] = val));
            },
        });
    });
};
const proxyMethods = (Cmp, methods) => {
    const Prototype = Cmp.prototype;
    methods.forEach((methodName) => {
        Prototype[methodName] = function () {
            const args = arguments;
            return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
        };
    });
};
const proxyOutputs = (instance, el, events) => {
    events.forEach((eventName) => {
        // This event emitter is created so that angular doesn't complain. It's not actually used, and the native events that davinci dispatches will be used instead.
        // TODO: revisit this to see if it breaks something
        instance[eventName] = new EventEmitter();
    });
};
function ProxyCmp(opts) {
    const decorator = function (cls) {
        if (opts.inputs) {
            proxyInputs(cls, opts.inputs);
        }
        if (opts.methods) {
            proxyMethods(cls, opts.methods);
        }
        return cls;
    };
    return decorator;
}

/**
 * A `davinci-option` is a data element for controls that allowed slotted data like `davinci-drop-down`
 */
let DavinciOptionComponent = class DavinciOptionComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciOptionComponent, isStandalone: true, selector: "davinci-option", inputs: { value: "value", selected: "selected", highlighted: "highlighted", disabled: "disabled" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciOptionComponent = __decorate([
    ProxyCmp({ inputs: ['value', 'selected', 'highlighted', 'disabled'] })
], DavinciOptionComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-option',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['value', 'selected', 'highlighted', 'disabled'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciOptionComponent as a standalone component instead */
class DavinciOptionModule {
}
DavinciOptionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciOptionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionModule, imports: [DavinciOptionComponent], exports: [DavinciOptionComponent] });
DavinciOptionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionModule, imports: [DavinciOptionComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciOptionComponent],
                    exports: [DavinciOptionComponent],
                }]
        }] });

/**
 * A `davinci-option-group` can be used to group `davinci-option` elements inside a `davinci-drop-down`
 */
let DavinciOptionGroupComponent = class DavinciOptionGroupComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciOptionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionGroupComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciOptionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciOptionGroupComponent, isStandalone: true, selector: "davinci-option-group", inputs: { label: "label" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciOptionGroupComponent = __decorate([
    ProxyCmp({ inputs: ['label'] })
], DavinciOptionGroupComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionGroupComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-option-group',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['label'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciOptionGroupComponent as a standalone component instead */
class DavinciOptionGroupModule {
}
DavinciOptionGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciOptionGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionGroupModule, imports: [DavinciOptionGroupComponent], exports: [DavinciOptionGroupComponent] });
DavinciOptionGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionGroupModule, imports: [DavinciOptionGroupComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciOptionGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciOptionGroupComponent],
                    exports: [DavinciOptionGroupComponent],
                }]
        }] });

/**
 * A `davinci-spinner` shows the progress of an operation with unknown duration.
 */
let DavinciSpinnerComponent = class DavinciSpinnerComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSpinnerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciSpinnerComponent, isStandalone: true, selector: "davinci-spinner", inputs: { label: "label", below: "below" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciSpinnerComponent = __decorate([
    ProxyCmp({ inputs: ['label', 'below'] })
], DavinciSpinnerComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSpinnerComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-spinner',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['label', 'below'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciSpinnerComponent as a standalone component instead */
class DavinciSpinnerModule {
}
DavinciSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciSpinnerModule, imports: [DavinciSpinnerComponent], exports: [DavinciSpinnerComponent] });
DavinciSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSpinnerModule, imports: [DavinciSpinnerComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciSpinnerComponent],
                    exports: [DavinciSpinnerComponent],
                }]
        }] });

/**
 * A <davinci-icon> is a wrapper for material-icons.
 */
let DavinciIconComponent = class DavinciIconComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciIconComponent, isStandalone: true, selector: "davinci-icon", inputs: { icon: "icon" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciIconComponent = __decorate([
    ProxyCmp({ inputs: ['icon'] })
], DavinciIconComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-icon',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['icon'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciIconComponent as a standalone component instead */
class DavinciIconModule {
}
DavinciIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconModule, imports: [DavinciIconComponent], exports: [DavinciIconComponent] });
DavinciIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconModule, imports: [DavinciIconComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciIconComponent],
                    exports: [DavinciIconComponent],
                }]
        }] });

/**
 * A `davinci-icon-ref` displays a svg as icon.
 */
let DavinciIconRefComponent = class DavinciIconRefComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciIconRefComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconRefComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciIconRefComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciIconRefComponent, isStandalone: true, selector: "davinci-icon-ref", inputs: { src: "src" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciIconRefComponent = __decorate([
    ProxyCmp({ inputs: ['src'] })
], DavinciIconRefComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconRefComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-icon-ref',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['src'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciIconRefComponent as a standalone component instead */
class DavinciIconRefModule {
}
DavinciIconRefModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconRefModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciIconRefModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconRefModule, imports: [DavinciIconRefComponent], exports: [DavinciIconRefComponent] });
DavinciIconRefModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconRefModule, imports: [DavinciIconRefComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciIconRefModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciIconRefComponent],
                    exports: [DavinciIconRefComponent],
                }]
        }] });

/**
 * A `davinci-drop-down` is a simple dropdown list and combo-box.
 * If used as a combo-box (editable), the content of the text-field displays the value instead of the selection.
 */
let DavinciDropDownComponent = class DavinciDropDownComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciDropDownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDropDownComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciDropDownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciDropDownComponent, isStandalone: true, selector: "davinci-drop-down", inputs: { name: "name", placeholder: "placeholder", editable: "editable", disabled: "disabled", loading: "loading", label: "label", iconSrc: "iconSrc", error: "error", warning: "warning", wideList: "wideList", data: "data", value: "value", expanded: "expanded", contentRenderer: "contentRenderer" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciDropDownComponent = __decorate([
    ProxyCmp({
        inputs: [
            'name',
            'placeholder',
            'editable',
            'disabled',
            'loading',
            'label',
            'iconSrc',
            'error',
            'warning',
            'wideList',
            'data',
            'value',
            'expanded',
            'contentRenderer',
        ],
    })
], DavinciDropDownComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDropDownComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-drop-down',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'name',
                        'placeholder',
                        'editable',
                        'disabled',
                        'loading',
                        'label',
                        'iconSrc',
                        'error',
                        'warning',
                        'wideList',
                        'data',
                        'value',
                        'expanded',
                        'contentRenderer',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciDropDownComponent as a standalone component instead */
class DavinciDropDownModule {
}
DavinciDropDownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDropDownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciDropDownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciDropDownModule, imports: [DavinciDropDownComponent], exports: [DavinciDropDownComponent] });
DavinciDropDownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDropDownModule, imports: [DavinciDropDownComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDropDownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciDropDownComponent],
                    exports: [DavinciDropDownComponent],
                }]
        }] });

/**
 * A `davinci-auto-suggest` is a specialization of the 'davinci-drop-down' with auto suggestion.
 * Searches a list for related keywords, phrases and items, which may match the input string.
 */
let DavinciAutoSuggestComponent = class DavinciAutoSuggestComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciAutoSuggestComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciAutoSuggestComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciAutoSuggestComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciAutoSuggestComponent, isStandalone: true, selector: "davinci-auto-suggest", inputs: { name: "name", placeholder: "placeholder", editable: "editable", disabled: "disabled", loading: "loading", label: "label", iconSrc: "iconSrc", error: "error", warning: "warning", wideList: "wideList", data: "data", value: "value", expanded: "expanded", contentRenderer: "contentRenderer", minLength: "minLength" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciAutoSuggestComponent = __decorate([
    ProxyCmp({
        inputs: [
            'name',
            'placeholder',
            'editable',
            'disabled',
            'loading',
            'label',
            'iconSrc',
            'error',
            'warning',
            'wideList',
            'data',
            'value',
            'expanded',
            'contentRenderer',
            'minLength',
        ],
    })
], DavinciAutoSuggestComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciAutoSuggestComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-auto-suggest',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'name',
                        'placeholder',
                        'editable',
                        'disabled',
                        'loading',
                        'label',
                        'iconSrc',
                        'error',
                        'warning',
                        'wideList',
                        'data',
                        'value',
                        'expanded',
                        'contentRenderer',
                        'minLength',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciAutoSuggestComponent as a standalone component instead */
class DavinciAutoSuggestModule {
}
DavinciAutoSuggestModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciAutoSuggestModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciAutoSuggestModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciAutoSuggestModule, imports: [DavinciAutoSuggestComponent], exports: [DavinciAutoSuggestComponent] });
DavinciAutoSuggestModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciAutoSuggestModule, imports: [DavinciAutoSuggestComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciAutoSuggestModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciAutoSuggestComponent],
                    exports: [DavinciAutoSuggestComponent],
                }]
        }] });

/**
 * A `davinci-balloon` displays an overlay on top of a specified element.
 */
let DavinciBalloonComponent = class DavinciBalloonComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciBalloonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBalloonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciBalloonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciBalloonComponent, isStandalone: true, selector: "davinci-balloon", inputs: { position: "position", alignment: "alignment", for: "for", type: "type", headline: "headline", show: "show", modal: "modal", icon: "icon" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciBalloonComponent = __decorate([
    ProxyCmp({
        inputs: [
            'position',
            'alignment',
            'for',
            'type',
            'headline',
            'show',
            'modal',
            'icon',
        ],
    })
], DavinciBalloonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBalloonComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-balloon',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'position',
                        'alignment',
                        'for',
                        'type',
                        'headline',
                        'show',
                        'modal',
                        'icon',
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciBalloonComponent as a standalone component instead */
class DavinciBalloonModule {
}
DavinciBalloonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBalloonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciBalloonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciBalloonModule, imports: [DavinciBalloonComponent], exports: [DavinciBalloonComponent] });
DavinciBalloonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBalloonModule, imports: [DavinciBalloonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBalloonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciBalloonComponent],
                    exports: [DavinciBalloonComponent],
                }]
        }] });

/**
 * A `davinci-breadcrumb` indicates the current page’s location.
 * It consists of several `davinci-breadcrumb-item`s which contain a link to a specific page.
 */
let DavinciBreadcrumbComponent = class DavinciBreadcrumbComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciBreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciBreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciBreadcrumbComponent, isStandalone: true, selector: "davinci-breadcrumb", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciBreadcrumbComponent = __decorate([
    ProxyCmp({ inputs: [] })
], DavinciBreadcrumbComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-breadcrumb',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciBreadcrumbComponent as a standalone component instead */
class DavinciBreadcrumbModule {
}
DavinciBreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciBreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbModule, imports: [DavinciBreadcrumbComponent], exports: [DavinciBreadcrumbComponent] });
DavinciBreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbModule, imports: [DavinciBreadcrumbComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciBreadcrumbComponent],
                    exports: [DavinciBreadcrumbComponent],
                }]
        }] });

/**
 * A `davinci-breadcrumb-item` links to a page.
 * It's a part of a `davinci-breadcrumb` to navigate quickly within page hierarchy.
 */
let DavinciBreadcrumbItemComponent = class DavinciBreadcrumbItemComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciBreadcrumbItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbItemComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciBreadcrumbItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciBreadcrumbItemComponent, isStandalone: true, selector: "davinci-breadcrumb-item", inputs: { label: "label", href: "href" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciBreadcrumbItemComponent = __decorate([
    ProxyCmp({ inputs: ['label', 'href'] })
], DavinciBreadcrumbItemComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbItemComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-breadcrumb-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['label', 'href'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciBreadcrumbItemComponent as a standalone component instead */
class DavinciBreadcrumbItemModule {
}
DavinciBreadcrumbItemModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbItemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciBreadcrumbItemModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbItemModule, imports: [DavinciBreadcrumbItemComponent], exports: [DavinciBreadcrumbItemComponent] });
DavinciBreadcrumbItemModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbItemModule, imports: [DavinciBreadcrumbItemComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciBreadcrumbItemModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciBreadcrumbItemComponent],
                    exports: [DavinciBreadcrumbItemComponent],
                }]
        }] });

/**
 * A `davinci-button` which can be activated using mouse click, space- or enter-key. It can also be used as a toggle button.
 * Style can be influenced using the type attribute. If toggle is set, it can be used with a `davinci-toggle-group`.
 */
let DavinciButtonComponent = class DavinciButtonComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'submit']);
    }
};
DavinciButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciButtonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciButtonComponent, isStandalone: true, selector: "davinci-button", inputs: { selected: "selected", type: "type", icon: "icon", iconSrc: "iconSrc", iconPosition: "iconPosition", toggle: "toggle", name: "name", value: "value", disabled: "disabled" }, outputs: { change: "change", submit: "submit" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciButtonComponent = __decorate([
    ProxyCmp({
        inputs: [
            'selected',
            'type',
            'icon',
            'iconSrc',
            'iconPosition',
            'toggle',
            'name',
            'value',
            'disabled',
        ],
    })
], DavinciButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciButtonComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-button',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'selected',
                        'type',
                        'icon',
                        'iconSrc',
                        'iconPosition',
                        'toggle',
                        'name',
                        'value',
                        'disabled',
                    ],
                    outputs: ['change', 'submit'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciButtonComponent as a standalone component instead */
class DavinciButtonModule {
}
DavinciButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciButtonModule, imports: [DavinciButtonComponent], exports: [DavinciButtonComponent] });
DavinciButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciButtonModule, imports: [DavinciButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciButtonComponent],
                    exports: [DavinciButtonComponent],
                }]
        }] });

/**
 * A `davinci-callout` is used to inform the user.
 * It shows information in different visual styles (aka *types*).
 */
let DavinciCalloutComponent = class DavinciCalloutComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['remove']);
    }
};
DavinciCalloutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCalloutComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciCalloutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciCalloutComponent, isStandalone: true, selector: "davinci-callout", inputs: { type: "type", closeable: "closeable" }, outputs: { remove: "remove" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciCalloutComponent = __decorate([
    ProxyCmp({ inputs: ['type', 'closeable'] })
], DavinciCalloutComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCalloutComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-callout',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['type', 'closeable'],
                    outputs: ['remove'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciCalloutComponent as a standalone component instead */
class DavinciCalloutModule {
}
DavinciCalloutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCalloutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciCalloutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciCalloutModule, imports: [DavinciCalloutComponent], exports: [DavinciCalloutComponent] });
DavinciCalloutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCalloutModule, imports: [DavinciCalloutComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCalloutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciCalloutComponent],
                    exports: [DavinciCalloutComponent],
                }]
        }] });

/**
 * A `davinci-checkbox` is a selection control that allow the user to select multiple options from a list of choices, including all or none.
 * It can be used within a `davinci-toggle-group`.
 */
let DavinciCheckboxComponent = class DavinciCheckboxComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciCheckboxComponent, isStandalone: true, selector: "davinci-checkbox", inputs: { checked: "checked", disabled: "disabled", error: "error", name: "name", value: "value" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciCheckboxComponent = __decorate([
    ProxyCmp({ inputs: ['checked', 'disabled', 'error', 'name', 'value'] })
], DavinciCheckboxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-checkbox',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['checked', 'disabled', 'error', 'name', 'value'],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciCheckboxComponent as a standalone component instead */
class DavinciCheckboxModule {
}
DavinciCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciCheckboxModule, imports: [DavinciCheckboxComponent], exports: [DavinciCheckboxComponent] });
DavinciCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCheckboxModule, imports: [DavinciCheckboxComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciCheckboxComponent],
                    exports: [DavinciCheckboxComponent],
                }]
        }] });

/**
 * A `davinci-collapse` can be used to show and hide content.
 */
let DavinciCollapseComponent = class DavinciCollapseComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['open-state-change']);
    }
};
DavinciCollapseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCollapseComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciCollapseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciCollapseComponent, isStandalone: true, selector: "davinci-collapse", inputs: { open: "open", prependIcon: "prependIcon", collapsedTitle: "collapsedTitle", expandedTitle: "expandedTitle" }, outputs: { "open-state-change": "open-state-change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciCollapseComponent = __decorate([
    ProxyCmp({
        inputs: ['open', 'prependIcon', 'collapsedTitle', 'expandedTitle'],
    })
], DavinciCollapseComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCollapseComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-collapse',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['open', 'prependIcon', 'collapsedTitle', 'expandedTitle'],
                    outputs: ['open-state-change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciCollapseComponent as a standalone component instead */
class DavinciCollapseModule {
}
DavinciCollapseModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCollapseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciCollapseModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciCollapseModule, imports: [DavinciCollapseComponent], exports: [DavinciCollapseComponent] });
DavinciCollapseModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCollapseModule, imports: [DavinciCollapseComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciCollapseModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciCollapseComponent],
                    exports: [DavinciCollapseComponent],
                }]
        }] });

/**
 * A `davinci-dnd-file-chooser` is used to select one or multiple files.
 * User can either drop files or open the file-chooser.
 */
let DavinciDnDFileChooserComponent = class DavinciDnDFileChooserComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change']);
    }
};
DavinciDnDFileChooserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDnDFileChooserComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciDnDFileChooserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciDnDFileChooserComponent, isStandalone: true, selector: "davinci-dnd-file-chooser", inputs: { labelDrop: "labelDrop", labelBrowse: "labelBrowse", accept: "accept", disabled: "disabled", files: "files" }, outputs: { change: "change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciDnDFileChooserComponent = __decorate([
    ProxyCmp({
        inputs: ['labelDrop', 'labelBrowse', 'accept', 'disabled', 'files'],
    })
], DavinciDnDFileChooserComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDnDFileChooserComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-dnd-file-chooser',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['labelDrop', 'labelBrowse', 'accept', 'disabled', 'files'],
                    outputs: ['change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciDnDFileChooserComponent as a standalone component instead */
class DavinciDnDFileChooserModule {
}
DavinciDnDFileChooserModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDnDFileChooserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciDnDFileChooserModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciDnDFileChooserModule, imports: [DavinciDnDFileChooserComponent], exports: [DavinciDnDFileChooserComponent] });
DavinciDnDFileChooserModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDnDFileChooserModule, imports: [DavinciDnDFileChooserComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciDnDFileChooserModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciDnDFileChooserComponent],
                    exports: [DavinciDnDFileChooserComponent],
                }]
        }] });

/**
 * A `davinci-file-chooser` opens the systems file dialog and lets the user choose one or multiple files.
 * The `davinci-file-chooser` is shown as `<davinci-button>`.
 *
 * The button styles can be influenced using the `button-type` attribute.
 */
let DavinciFileChooserComponent = class DavinciFileChooserComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change']);
    }
};
DavinciFileChooserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFileChooserComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciFileChooserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciFileChooserComponent, isStandalone: true, selector: "davinci-file-chooser", inputs: { value: "value", accept: "accept", multiple: "multiple", disabled: "disabled", name: "name", buttonType: "buttonType", icon: "icon", iconSrc: "iconSrc", files: "files" }, outputs: { change: "change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciFileChooserComponent = __decorate([
    ProxyCmp({
        inputs: [
            'value',
            'accept',
            'multiple',
            'disabled',
            'name',
            'buttonType',
            'icon',
            'iconSrc',
            'files',
        ],
    })
], DavinciFileChooserComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFileChooserComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-file-chooser',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'value',
                        'accept',
                        'multiple',
                        'disabled',
                        'name',
                        'buttonType',
                        'icon',
                        'iconSrc',
                        'files',
                    ],
                    outputs: ['change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciFileChooserComponent as a standalone component instead */
class DavinciFileChooserModule {
}
DavinciFileChooserModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFileChooserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciFileChooserModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciFileChooserModule, imports: [DavinciFileChooserComponent], exports: [DavinciFileChooserComponent] });
DavinciFileChooserModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFileChooserModule, imports: [DavinciFileChooserComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFileChooserModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciFileChooserComponent],
                    exports: [DavinciFileChooserComponent],
                }]
        }] });

/**
 * A `davinci-slider` can be used to choose a value between a specific range.
 */
let DavinciSliderComponent = class DavinciSliderComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSliderComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciSliderComponent, isStandalone: true, selector: "davinci-slider", inputs: { min: "min", max: "max", ticks: "ticks", legend: "legend", unit: "unit", disabled: "disabled", iconLeft: "iconLeft", iconRight: "iconRight", iconSrcLeft: "iconSrcLeft", iconSrcRight: "iconSrcRight", showValueField: "showValueField", value: "value" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciSliderComponent = __decorate([
    ProxyCmp({
        inputs: [
            'min',
            'max',
            'ticks',
            'legend',
            'unit',
            'disabled',
            'iconLeft',
            'iconRight',
            'iconSrcLeft',
            'iconSrcRight',
            'showValueField',
            'value',
        ],
    })
], DavinciSliderComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSliderComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-slider',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'min',
                        'max',
                        'ticks',
                        'legend',
                        'unit',
                        'disabled',
                        'iconLeft',
                        'iconRight',
                        'iconSrcLeft',
                        'iconSrcRight',
                        'showValueField',
                        'value',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciSliderComponent as a standalone component instead */
class DavinciSliderModule {
}
DavinciSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciSliderModule, imports: [DavinciSliderComponent], exports: [DavinciSliderComponent] });
DavinciSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSliderModule, imports: [DavinciSliderComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciSliderComponent],
                    exports: [DavinciSliderComponent],
                }]
        }] });

/**
 * A `davinci-flexi-slider` can be used to choose a value from a predefined set of values displayed in a legend.
 */
let DavinciFlexiSliderComponent = class DavinciFlexiSliderComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciFlexiSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlexiSliderComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciFlexiSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciFlexiSliderComponent, isStandalone: true, selector: "davinci-flexi-slider", inputs: { ticks: "ticks", legend: "legend", unit: "unit", disabled: "disabled", iconLeft: "iconLeft", iconRight: "iconRight", iconSrcLeft: "iconSrcLeft", iconSrcRight: "iconSrcRight", showValueField: "showValueField", valueSet: "valueSet", value: "value", max: "max", min: "min" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciFlexiSliderComponent = __decorate([
    ProxyCmp({
        inputs: [
            'ticks',
            'legend',
            'unit',
            'disabled',
            'iconLeft',
            'iconRight',
            'iconSrcLeft',
            'iconSrcRight',
            'showValueField',
            'valueSet',
            'value',
            'max',
            'min',
        ],
    })
], DavinciFlexiSliderComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlexiSliderComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-flexi-slider',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'ticks',
                        'legend',
                        'unit',
                        'disabled',
                        'iconLeft',
                        'iconRight',
                        'iconSrcLeft',
                        'iconSrcRight',
                        'showValueField',
                        'valueSet',
                        'value',
                        'max',
                        'min',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciFlexiSliderComponent as a standalone component instead */
class DavinciFlexiSliderModule {
}
DavinciFlexiSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlexiSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciFlexiSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlexiSliderModule, imports: [DavinciFlexiSliderComponent], exports: [DavinciFlexiSliderComponent] });
DavinciFlexiSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlexiSliderModule, imports: [DavinciFlexiSliderComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlexiSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciFlexiSliderComponent],
                    exports: [DavinciFlexiSliderComponent],
                }]
        }] });

/**
 * A `davinci-flyout-menu-item` displays an item in a `davinci-flyout-menu` and handles slotted subitems as "sub-menu".
 */
let DavinciFlyoutMenuItemComponent = class DavinciFlyoutMenuItemComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['menu-click']);
    }
};
DavinciFlyoutMenuItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuItemComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciFlyoutMenuItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciFlyoutMenuItemComponent, isStandalone: true, selector: "davinci-flyout-menu-item", inputs: { disabled: "disabled", icon: "icon", iconSrc: "iconSrc", label: "label", left: "left", open: "open", iconPlaceholder: "iconPlaceholder", submenuPlaceholder: "submenuPlaceholder" }, outputs: { "menu-click": "menu-click" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciFlyoutMenuItemComponent = __decorate([
    ProxyCmp({
        inputs: [
            'disabled',
            'icon',
            'iconSrc',
            'label',
            'left',
            'open',
            'iconPlaceholder',
            'submenuPlaceholder',
        ],
    })
], DavinciFlyoutMenuItemComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuItemComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-flyout-menu-item',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'disabled',
                        'icon',
                        'iconSrc',
                        'label',
                        'left',
                        'open',
                        'iconPlaceholder',
                        'submenuPlaceholder',
                    ],
                    outputs: ['menu-click'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciFlyoutMenuItemComponent as a standalone component instead */
class DavinciFlyoutMenuItemModule {
}
DavinciFlyoutMenuItemModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuItemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciFlyoutMenuItemModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuItemModule, imports: [DavinciFlyoutMenuItemComponent], exports: [DavinciFlyoutMenuItemComponent] });
DavinciFlyoutMenuItemModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuItemModule, imports: [DavinciFlyoutMenuItemComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuItemModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciFlyoutMenuItemComponent],
                    exports: [DavinciFlyoutMenuItemComponent],
                }]
        }] });

/**
 * A `davinci-flyout-menu` displays a menu in form of a button that opens a sub menu with an arbitrary number of `davinci-flyout-menu-item`.
 */
let DavinciFlyoutMenuComponent = class DavinciFlyoutMenuComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['menu-click']);
    }
};
DavinciFlyoutMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciFlyoutMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciFlyoutMenuComponent, isStandalone: true, selector: "davinci-flyout-menu", inputs: { disabled: "disabled", label: "label", left: "left", open: "open", iconPlaceholder: "iconPlaceholder", submenuPlaceholder: "submenuPlaceholder", externalControl: "externalControl", icon: "icon", iconSrc: "iconSrc" }, outputs: { "menu-click": "menu-click" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciFlyoutMenuComponent = __decorate([
    ProxyCmp({
        inputs: [
            'disabled',
            'label',
            'left',
            'open',
            'iconPlaceholder',
            'submenuPlaceholder',
            'externalControl',
            'icon',
            'iconSrc',
        ],
    })
], DavinciFlyoutMenuComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-flyout-menu',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'disabled',
                        'label',
                        'left',
                        'open',
                        'iconPlaceholder',
                        'submenuPlaceholder',
                        'externalControl',
                        'icon',
                        'iconSrc',
                    ],
                    outputs: ['menu-click'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciFlyoutMenuComponent as a standalone component instead */
class DavinciFlyoutMenuModule {
}
DavinciFlyoutMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciFlyoutMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuModule, imports: [DavinciFlyoutMenuComponent], exports: [DavinciFlyoutMenuComponent] });
DavinciFlyoutMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuModule, imports: [DavinciFlyoutMenuComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciFlyoutMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciFlyoutMenuComponent],
                    exports: [DavinciFlyoutMenuComponent],
                }]
        }] });

/**
 * A `davinci-link` is an interactive element that suggests it can be clicked.
 * Links are used to allow users to navigate through content such as web pages, files or images.
 * When clicking the link, users are automatically directed to the linked page or object.
 *
 * A `davinci-link` is a simple wrapper around the `a` element.
 *
 * Style can be influenced using the `inverted`, `inside-text` and `icon*` attributes.
 */
let DavinciLinkComponent = class DavinciLinkComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciLinkComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciLinkComponent, isStandalone: true, selector: "davinci-link", inputs: { href: "href", target: "target", download: "download", icon: "icon", iconPosition: "iconPosition", iconSrc: "iconSrc", inverted: "inverted", insideText: "insideText", disabled: "disabled" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciLinkComponent = __decorate([
    ProxyCmp({
        inputs: [
            'href',
            'target',
            'download',
            'icon',
            'iconPosition',
            'iconSrc',
            'inverted',
            'insideText',
            'disabled',
        ],
    })
], DavinciLinkComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciLinkComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-link',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'href',
                        'target',
                        'download',
                        'icon',
                        'iconPosition',
                        'iconSrc',
                        'inverted',
                        'insideText',
                        'disabled',
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciLinkComponent as a standalone component instead */
class DavinciLinkModule {
}
DavinciLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciLinkModule, imports: [DavinciLinkComponent], exports: [DavinciLinkComponent] });
DavinciLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciLinkModule, imports: [DavinciLinkComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciLinkComponent],
                    exports: [DavinciLinkComponent],
                }]
        }] });

/**
 * A `davinci-multi-select` is a specialization of the 'davinci-drop-down' to support multiple value selections.
 * Each entry has its own checkbox to display it's state.
 * If used as a combo-box (editable), the content of the text-field displays the input instead of the selections.
 */
let DavinciMultiSelectComponent = class DavinciMultiSelectComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['input', 'change']);
    }
};
DavinciMultiSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciMultiSelectComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciMultiSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciMultiSelectComponent, isStandalone: true, selector: "davinci-multi-select", inputs: { name: "name", placeholder: "placeholder", editable: "editable", disabled: "disabled", loading: "loading", label: "label", iconSrc: "iconSrc", error: "error", warning: "warning", wideList: "wideList", data: "data", value: "value", expanded: "expanded", contentRenderer: "contentRenderer", values: "values" }, outputs: { input: "input", change: "change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciMultiSelectComponent = __decorate([
    ProxyCmp({
        inputs: [
            'name',
            'placeholder',
            'editable',
            'disabled',
            'loading',
            'label',
            'iconSrc',
            'error',
            'warning',
            'wideList',
            'data',
            'value',
            'expanded',
            'contentRenderer',
            'values',
        ],
    })
], DavinciMultiSelectComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciMultiSelectComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-multi-select',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'name',
                        'placeholder',
                        'editable',
                        'disabled',
                        'loading',
                        'label',
                        'iconSrc',
                        'error',
                        'warning',
                        'wideList',
                        'data',
                        'value',
                        'expanded',
                        'contentRenderer',
                        'values',
                    ],
                    outputs: ['input', 'change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciMultiSelectComponent as a standalone component instead */
class DavinciMultiSelectModule {
}
DavinciMultiSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciMultiSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciMultiSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciMultiSelectModule, imports: [DavinciMultiSelectComponent], exports: [DavinciMultiSelectComponent] });
DavinciMultiSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciMultiSelectModule, imports: [DavinciMultiSelectComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciMultiSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciMultiSelectComponent],
                    exports: [DavinciMultiSelectComponent],
                }]
        }] });

/**
 * Number inputs for touch and desktop (classic).
 */
let DavinciNumberInputComponent = class DavinciNumberInputComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciNumberInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumberInputComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciNumberInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciNumberInputComponent, isStandalone: true, selector: "davinci-number-input", inputs: { bare: "bare", disabled: "disabled", converter: "converter", error: "error", label: "label", max: "max", min: "min", unitPrefix: "unitPrefix", unitSuffix: "unitSuffix", noStepAlign: "noStepAlign", placeholder: "placeholder", readonly: "readonly", step: "step", touch: "touch", value: "value", warn: "warn" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciNumberInputComponent = __decorate([
    ProxyCmp({
        inputs: [
            'bare',
            'disabled',
            'converter',
            'error',
            'label',
            'max',
            'min',
            'unitPrefix',
            'unitSuffix',
            'noStepAlign',
            'placeholder',
            'readonly',
            'step',
            'touch',
            'value',
            'warn',
        ],
    })
], DavinciNumberInputComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumberInputComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-number-input',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'bare',
                        'disabled',
                        'converter',
                        'error',
                        'label',
                        'max',
                        'min',
                        'unitPrefix',
                        'unitSuffix',
                        'noStepAlign',
                        'placeholder',
                        'readonly',
                        'step',
                        'touch',
                        'value',
                        'warn',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciNumberInputComponent as a standalone component instead */
class DavinciNumberInputModule {
}
DavinciNumberInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumberInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciNumberInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumberInputModule, imports: [DavinciNumberInputComponent], exports: [DavinciNumberInputComponent] });
DavinciNumberInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumberInputModule, imports: [DavinciNumberInputComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumberInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciNumberInputComponent],
                    exports: [DavinciNumberInputComponent],
                }]
        }] });

/**
 * A `davinci-numeric-field` is a text field that only allows to input numbers.
 * The value can also be changed using up-/down-buttons.
 */
let DavinciNumericFieldComponent = class DavinciNumericFieldComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciNumericFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumericFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciNumericFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciNumericFieldComponent, isStandalone: true, selector: "davinci-numeric-field", inputs: { type: "type", min: "min", max: "max", ticks: "ticks", alignToTicks: "alignToTicks", groupSeparator: "groupSeparator", decimalSeparator: "decimalSeparator", formatPattern: "formatPattern", unit: "unit", disabled: "disabled", value: "value" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciNumericFieldComponent = __decorate([
    ProxyCmp({
        inputs: [
            'type',
            'min',
            'max',
            'ticks',
            'alignToTicks',
            'groupSeparator',
            'decimalSeparator',
            'formatPattern',
            'unit',
            'disabled',
            'value',
        ],
    })
], DavinciNumericFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumericFieldComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-numeric-field',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'type',
                        'min',
                        'max',
                        'ticks',
                        'alignToTicks',
                        'groupSeparator',
                        'decimalSeparator',
                        'formatPattern',
                        'unit',
                        'disabled',
                        'value',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciNumericFieldComponent as a standalone component instead */
class DavinciNumericFieldModule {
}
DavinciNumericFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumericFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciNumericFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumericFieldModule, imports: [DavinciNumericFieldComponent], exports: [DavinciNumericFieldComponent] });
DavinciNumericFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumericFieldModule, imports: [DavinciNumericFieldComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciNumericFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciNumericFieldComponent],
                    exports: [DavinciNumericFieldComponent],
                }]
        }] });

/**
 * A `davinci-popup-list` is a list that can be revealed.
 */
let DavinciPopupListComponent = class DavinciPopupListComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['itemclick']);
    }
};
DavinciPopupListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciPopupListComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciPopupListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciPopupListComponent, isStandalone: true, selector: "davinci-popup-list", inputs: { opentop: "opentop", show: "show", index: "index" }, outputs: { itemclick: "itemclick" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciPopupListComponent = __decorate([
    ProxyCmp({ inputs: ['opentop', 'show', 'index'] })
], DavinciPopupListComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciPopupListComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-popup-list',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['opentop', 'show', 'index'],
                    outputs: ['itemclick'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciPopupListComponent as a standalone component instead */
class DavinciPopupListModule {
}
DavinciPopupListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciPopupListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciPopupListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciPopupListModule, imports: [DavinciPopupListComponent], exports: [DavinciPopupListComponent] });
DavinciPopupListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciPopupListModule, imports: [DavinciPopupListComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciPopupListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciPopupListComponent],
                    exports: [DavinciPopupListComponent],
                }]
        }] });

/**
 * A `davinci-progress-line` is used to display the current progress of a task.
 */
let DavinciProgressLineComponent = class DavinciProgressLineComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciProgressLineComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciProgressLineComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciProgressLineComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciProgressLineComponent, isStandalone: true, selector: "davinci-progress-line", inputs: { label: "label", message: "message", percentage: "percentage" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciProgressLineComponent = __decorate([
    ProxyCmp({ inputs: ['label', 'message', 'percentage'] })
], DavinciProgressLineComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciProgressLineComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-progress-line',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['label', 'message', 'percentage'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciProgressLineComponent as a standalone component instead */
class DavinciProgressLineModule {
}
DavinciProgressLineModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciProgressLineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciProgressLineModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciProgressLineModule, imports: [DavinciProgressLineComponent], exports: [DavinciProgressLineComponent] });
DavinciProgressLineModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciProgressLineModule, imports: [DavinciProgressLineComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciProgressLineModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciProgressLineComponent],
                    exports: [DavinciProgressLineComponent],
                }]
        }] });

/**
 * A `davinci-radio-button` is a selection control that allow users to switch between options or to turn a setting on or off.
 * Can be used within a toggle-group.
 */
let DavinciRadioButtonComponent = class DavinciRadioButtonComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciRadioButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRadioButtonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciRadioButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciRadioButtonComponent, isStandalone: true, selector: "davinci-radio-button", inputs: { checked: "checked", disabled: "disabled", name: "name", value: "value" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciRadioButtonComponent = __decorate([
    ProxyCmp({ inputs: ['checked', 'disabled', 'name', 'value'] })
], DavinciRadioButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRadioButtonComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-radio-button',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['checked', 'disabled', 'name', 'value'],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciRadioButtonComponent as a standalone component instead */
class DavinciRadioButtonModule {
}
DavinciRadioButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRadioButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciRadioButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciRadioButtonModule, imports: [DavinciRadioButtonComponent], exports: [DavinciRadioButtonComponent] });
DavinciRadioButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRadioButtonModule, imports: [DavinciRadioButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRadioButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciRadioButtonComponent],
                    exports: [DavinciRadioButtonComponent],
                }]
        }] });

/**
 * A `davinci-range-slider` can be used to define a value range.
 */
let DavinciRangeSliderComponent = class DavinciRangeSliderComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciRangeSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRangeSliderComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciRangeSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciRangeSliderComponent, isStandalone: true, selector: "davinci-range-slider", inputs: { min: "min", max: "max", ticks: "ticks", legend: "legend", unit: "unit", disabled: "disabled", iconLeft: "iconLeft", iconRight: "iconRight", iconSrcLeft: "iconSrcLeft", iconSrcRight: "iconSrcRight", showValueField: "showValueField", value: "value" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciRangeSliderComponent = __decorate([
    ProxyCmp({
        inputs: [
            'min',
            'max',
            'ticks',
            'legend',
            'unit',
            'disabled',
            'iconLeft',
            'iconRight',
            'iconSrcLeft',
            'iconSrcRight',
            'showValueField',
            'value',
        ],
    })
], DavinciRangeSliderComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRangeSliderComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-range-slider',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'min',
                        'max',
                        'ticks',
                        'legend',
                        'unit',
                        'disabled',
                        'iconLeft',
                        'iconRight',
                        'iconSrcLeft',
                        'iconSrcRight',
                        'showValueField',
                        'value',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciRangeSliderComponent as a standalone component instead */
class DavinciRangeSliderModule {
}
DavinciRangeSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRangeSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciRangeSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciRangeSliderModule, imports: [DavinciRangeSliderComponent], exports: [DavinciRangeSliderComponent] });
DavinciRangeSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRangeSliderModule, imports: [DavinciRangeSliderComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciRangeSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciRangeSliderComponent],
                    exports: [DavinciRangeSliderComponent],
                }]
        }] });

/**
 * A `davinci-search-field` is a specialization of a `davinci-drop-down` list.
 *  But it's always editable and highlights the input in the dropdown list.
 *  It enables the user to find words, sentences and numbers in a collection of data.
 *  However you can customize the styling and highlighting via contentRenderer.
 *  Use the data property for setting the dropdown list.
 */
let DavinciSearchFieldComponent = class DavinciSearchFieldComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciSearchFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSearchFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciSearchFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciSearchFieldComponent, isStandalone: true, selector: "davinci-search-field", inputs: { name: "name", placeholder: "placeholder", editable: "editable", disabled: "disabled", loading: "loading", label: "label", iconSrc: "iconSrc", error: "error", warning: "warning", wideList: "wideList", data: "data", value: "value", expanded: "expanded", contentRenderer: "contentRenderer" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciSearchFieldComponent = __decorate([
    ProxyCmp({
        inputs: [
            'name',
            'placeholder',
            'editable',
            'disabled',
            'loading',
            'label',
            'iconSrc',
            'error',
            'warning',
            'wideList',
            'data',
            'value',
            'expanded',
            'contentRenderer',
        ],
    })
], DavinciSearchFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSearchFieldComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-search-field',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'name',
                        'placeholder',
                        'editable',
                        'disabled',
                        'loading',
                        'label',
                        'iconSrc',
                        'error',
                        'warning',
                        'wideList',
                        'data',
                        'value',
                        'expanded',
                        'contentRenderer',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciSearchFieldComponent as a standalone component instead */
class DavinciSearchFieldModule {
}
DavinciSearchFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSearchFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciSearchFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciSearchFieldModule, imports: [DavinciSearchFieldComponent], exports: [DavinciSearchFieldComponent] });
DavinciSearchFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSearchFieldModule, imports: [DavinciSearchFieldComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciSearchFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciSearchFieldComponent],
                    exports: [DavinciSearchFieldComponent],
                }]
        }] });

/**
 * The `davinci-status-indicator` visualizes a boolean data type.
 * The default circles can be replaced with custom icons.
 */
let DavinciStatusIndicatorComponent = class DavinciStatusIndicatorComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciStatusIndicatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusIndicatorComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciStatusIndicatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciStatusIndicatorComponent, isStandalone: true, selector: "davinci-status-indicator", inputs: { status: "status", iconOn: "iconOn", iconOnSrc: "iconOnSrc", colorOn: "colorOn", iconOff: "iconOff", iconOffSrc: "iconOffSrc", colorOff: "colorOff", disabled: "disabled" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciStatusIndicatorComponent = __decorate([
    ProxyCmp({
        inputs: [
            'status',
            'iconOn',
            'iconOnSrc',
            'colorOn',
            'iconOff',
            'iconOffSrc',
            'colorOff',
            'disabled',
        ],
    })
], DavinciStatusIndicatorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusIndicatorComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-status-indicator',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'status',
                        'iconOn',
                        'iconOnSrc',
                        'colorOn',
                        'iconOff',
                        'iconOffSrc',
                        'colorOff',
                        'disabled',
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciStatusIndicatorComponent as a standalone component instead */
class DavinciStatusIndicatorModule {
}
DavinciStatusIndicatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciStatusIndicatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusIndicatorModule, imports: [DavinciStatusIndicatorComponent], exports: [DavinciStatusIndicatorComponent] });
DavinciStatusIndicatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusIndicatorModule, imports: [DavinciStatusIndicatorComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciStatusIndicatorComponent],
                    exports: [DavinciStatusIndicatorComponent],
                }]
        }] });

/**
 * A `davinci-status-line` informs the user about the status of a process.
 *
 * Status icon can be changed by setting the value attribute to `pending`, `success` and `error`.
 */
let DavinciStatusLineComponent = class DavinciStatusLineComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciStatusLineComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusLineComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciStatusLineComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciStatusLineComponent, isStandalone: true, selector: "davinci-status-line", inputs: { value: "value" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciStatusLineComponent = __decorate([
    ProxyCmp({ inputs: ['value'] })
], DavinciStatusLineComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusLineComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-status-line',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['value'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciStatusLineComponent as a standalone component instead */
class DavinciStatusLineModule {
}
DavinciStatusLineModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusLineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciStatusLineModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusLineModule, imports: [DavinciStatusLineComponent], exports: [DavinciStatusLineComponent] });
DavinciStatusLineModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusLineModule, imports: [DavinciStatusLineComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusLineModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciStatusLineComponent],
                    exports: [DavinciStatusLineComponent],
                }]
        }] });

/**
 * A `davinci-status-text` is a textual element that formats the text depending on the type. It is primarily dedicated to visualize status-information of form-elements.
 * This element is designed to work with other input elements like text-area or text-field.
 * If more then one state is defined, the one with higher priority takes precendence.
 */
let DavinciStatusTextComponent = class DavinciStatusTextComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciStatusTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusTextComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciStatusTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciStatusTextComponent, isStandalone: true, selector: "davinci-status-text", inputs: { error: "error", warning: "warning", success: "success" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciStatusTextComponent = __decorate([
    ProxyCmp({ inputs: ['error', 'warning', 'success'] })
], DavinciStatusTextComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusTextComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-status-text',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['error', 'warning', 'success'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciStatusTextComponent as a standalone component instead */
class DavinciStatusTextModule {
}
DavinciStatusTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciStatusTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusTextModule, imports: [DavinciStatusTextComponent], exports: [DavinciStatusTextComponent] });
DavinciStatusTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusTextModule, imports: [DavinciStatusTextComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciStatusTextModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciStatusTextComponent],
                    exports: [DavinciStatusTextComponent],
                }]
        }] });

/**
 * A `davinvi-tab` to be used as a slot element in `davinci-tabs`.
 */
let DavinciTabComponent = class DavinciTabComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['tab-update', '_change']);
    }
};
DavinciTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTabComponent, isStandalone: true, selector: "davinci-tab", inputs: { index: "index", selected: "selected", label: "label", disabled: "disabled", icon: "icon", iconSrc: "iconSrc" }, outputs: { "tab-update": "tab-update", _change: "_change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTabComponent = __decorate([
    ProxyCmp({
        inputs: ['index', 'selected', 'label', 'disabled', 'icon', 'iconSrc'],
    })
], DavinciTabComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-tab',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['index', 'selected', 'label', 'disabled', 'icon', 'iconSrc'],
                    outputs: ['tab-update', '_change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTabComponent as a standalone component instead */
class DavinciTabModule {
}
DavinciTabModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTabModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabModule, imports: [DavinciTabComponent], exports: [DavinciTabComponent] });
DavinciTabModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabModule, imports: [DavinciTabComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTabComponent],
                    exports: [DavinciTabComponent],
                }]
        }] });

/**
 * A `davinci-tabs` groups several `davinci-tab`s and shows a tab bar for switching between the *tab*s.
 */
let DavinciTabsComponent = class DavinciTabsComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['tab-change', 'close-tab']);
    }
};
DavinciTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabsComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTabsComponent, isStandalone: true, selector: "davinci-tabs", inputs: { type: "type", closeable: "closeable", selectedIndex: "selectedIndex" }, outputs: { "tab-change": "tab-change", "close-tab": "close-tab" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTabsComponent = __decorate([
    ProxyCmp({ inputs: ['type', 'closeable', 'selectedIndex'] })
], DavinciTabsComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabsComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-tabs',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['type', 'closeable', 'selectedIndex'],
                    outputs: ['tab-change', 'close-tab'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTabsComponent as a standalone component instead */
class DavinciTabsModule {
}
DavinciTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabsModule, imports: [DavinciTabsComponent], exports: [DavinciTabsComponent] });
DavinciTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabsModule, imports: [DavinciTabsComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTabsComponent],
                    exports: [DavinciTabsComponent],
                }]
        }] });

/**
 * A `davinci-tag` is a label that can be deleted. To be used as a slot within `davinci-tag-module`.
 * Tags are interactive elements used for classification and markup.
 * They work like keywords and allow users to quickly search and find content marked up with these keywords.
 */
let DavinciTagComponent = class DavinciTagComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['remove']);
    }
};
DavinciTagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTagComponent, isStandalone: true, selector: "davinci-tag", inputs: { name: "name", type: "type", iconSrc: "iconSrc" }, outputs: { remove: "remove" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTagComponent = __decorate([
    ProxyCmp({ inputs: ['name', 'type', 'iconSrc'] })
], DavinciTagComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-tag',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['name', 'type', 'iconSrc'],
                    outputs: ['remove'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTagComponent as a standalone component instead */
class DavinciTagModule {
}
DavinciTagModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTagModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModule, imports: [DavinciTagComponent], exports: [DavinciTagComponent] });
DavinciTagModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModule, imports: [DavinciTagComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTagComponent],
                    exports: [DavinciTagComponent],
                }]
        }] });

/**
 * A `davinci-tag-module` is used to represent user input in a concise way. They allow users to filter and find content.
 */
let DavinciTagModuleComponent = class DavinciTagModuleComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change']);
    }
};
DavinciTagModuleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModuleComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTagModuleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTagModuleComponent, isStandalone: true, selector: "davinci-tag-module", inputs: { value: "value", name: "name", labelClear: "labelClear" }, outputs: { change: "change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTagModuleComponent = __decorate([
    ProxyCmp({ inputs: ['value', 'name', 'labelClear'] })
], DavinciTagModuleComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModuleComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-tag-module',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['value', 'name', 'labelClear'],
                    outputs: ['change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTagModuleComponent as a standalone component instead */
class DavinciTagModuleModule {
}
DavinciTagModuleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModuleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTagModuleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModuleModule, imports: [DavinciTagModuleComponent], exports: [DavinciTagModuleComponent] });
DavinciTagModuleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModuleModule, imports: [DavinciTagModuleComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTagModuleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTagModuleComponent],
                    exports: [DavinciTagModuleComponent],
                }]
        }] });

/**
 * A `davinci-text-area` can be used to enter or edit multi-line-text.
 * It is taller than a `davinci-text-field` to indicate, that more than one line of text can be entered.
 * It does not support different input types like email or password, etc.
 */
let DavinciTextAreaComponent = class DavinciTextAreaComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input']);
    }
};
DavinciTextAreaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextAreaComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTextAreaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTextAreaComponent, isStandalone: true, selector: "davinci-text-area", inputs: { label: "label", placeholder: "placeholder", name: "name", required: "required", disabled: "disabled", readonly: "readonly", multiline: "multiline", error: "error", warning: "warning", value: "value" }, outputs: { change: "change", input: "input" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTextAreaComponent = __decorate([
    ProxyCmp({
        inputs: [
            'label',
            'placeholder',
            'name',
            'required',
            'disabled',
            'readonly',
            'multiline',
            'error',
            'warning',
            'value',
        ],
    })
], DavinciTextAreaComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextAreaComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-text-area',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'label',
                        'placeholder',
                        'name',
                        'required',
                        'disabled',
                        'readonly',
                        'multiline',
                        'error',
                        'warning',
                        'value',
                    ],
                    outputs: ['change', 'input'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTextAreaComponent as a standalone component instead */
class DavinciTextAreaModule {
}
DavinciTextAreaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextAreaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTextAreaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextAreaModule, imports: [DavinciTextAreaComponent], exports: [DavinciTextAreaComponent] });
DavinciTextAreaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextAreaModule, imports: [DavinciTextAreaComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextAreaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTextAreaComponent],
                    exports: [DavinciTextAreaComponent],
                }]
        }] });

/**
 * A `davinci-text-field` can be used to enter or edit a single line of text. It's used to enter email addresses and passwords as well.
 */
let DavinciTextFieldComponent = class DavinciTextFieldComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change', 'input', 'pattern-match-change']);
    }
};
DavinciTextFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTextFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTextFieldComponent, isStandalone: true, selector: "davinci-text-field", inputs: { name: "name", type: "type", label: "label", placeholder: "placeholder", required: "required", disabled: "disabled", error: "error", warning: "warning", readonly: "readonly", ignorePattern: "ignorePattern", pattern: "pattern", value: "value" }, outputs: { change: "change", input: "input", "pattern-match-change": "pattern-match-change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTextFieldComponent = __decorate([
    ProxyCmp({
        inputs: [
            'name',
            'type',
            'label',
            'placeholder',
            'required',
            'disabled',
            'error',
            'warning',
            'readonly',
            'ignorePattern',
            'pattern',
            'value',
        ],
    })
], DavinciTextFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextFieldComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-text-field',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'name',
                        'type',
                        'label',
                        'placeholder',
                        'required',
                        'disabled',
                        'error',
                        'warning',
                        'readonly',
                        'ignorePattern',
                        'pattern',
                        'value',
                    ],
                    outputs: ['change', 'input', 'pattern-match-change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTextFieldComponent as a standalone component instead */
class DavinciTextFieldModule {
}
DavinciTextFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTextFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextFieldModule, imports: [DavinciTextFieldComponent], exports: [DavinciTextFieldComponent] });
DavinciTextFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextFieldModule, imports: [DavinciTextFieldComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTextFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTextFieldComponent],
                    exports: [DavinciTextFieldComponent],
                }]
        }] });

/**
 * A `davinci-tile` is composed of a left-aligned image, a centered title and description and a right aligned icon.
 * The whole tile can be used as a link.
 */
let DavinciTileComponent = class DavinciTileComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciTileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTileComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciTileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciTileComponent, isStandalone: true, selector: "davinci-tile", inputs: { title: "title", description: "description", href: "href", target: "target", download: "download", disabled: "disabled", icon: "icon", iconSrc: "iconSrc" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciTileComponent = __decorate([
    ProxyCmp({
        inputs: [
            'title',
            'description',
            'href',
            'target',
            'download',
            'disabled',
            'icon',
            'iconSrc',
        ],
    })
], DavinciTileComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTileComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-tile',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'title',
                        'description',
                        'href',
                        'target',
                        'download',
                        'disabled',
                        'icon',
                        'iconSrc',
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciTileComponent as a standalone component instead */
class DavinciTileModule {
}
DavinciTileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciTileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciTileModule, imports: [DavinciTileComponent], exports: [DavinciTileComponent] });
DavinciTileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTileModule, imports: [DavinciTileComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciTileModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciTileComponent],
                    exports: [DavinciTileComponent],
                }]
        }] });

/**
 * A `davinci-toggle-group` groups multiple toggleable/selectable elements like checkbox, radio-button or button and emits the selected value on change.
 *
 * Supports all elements with a `value` and a `selected` or `checked` property.
 */
let DavinciToggleGroupComponent = class DavinciToggleGroupComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change']);
    }
};
DavinciToggleGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleGroupComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciToggleGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciToggleGroupComponent, isStandalone: true, selector: "davinci-toggle-group", inputs: { value: "value", disabled: "disabled", name: "name" }, outputs: { change: "change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciToggleGroupComponent = __decorate([
    ProxyCmp({ inputs: ['value', 'disabled', 'name'] })
], DavinciToggleGroupComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleGroupComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-toggle-group',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['value', 'disabled', 'name'],
                    outputs: ['change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciToggleGroupComponent as a standalone component instead */
class DavinciToggleGroupModule {
}
DavinciToggleGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciToggleGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleGroupModule, imports: [DavinciToggleGroupComponent], exports: [DavinciToggleGroupComponent] });
DavinciToggleGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleGroupModule, imports: [DavinciToggleGroupComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciToggleGroupComponent],
                    exports: [DavinciToggleGroupComponent],
                }]
        }] });

/**
 * A `davinci-toggle-switch` is used to switch between two states, such as turning a setting on or off.
 * Using mouse click, space- or enter-key to change the state
 *
 * Style can be influenced using `icon-*` attributes.
 */
let DavinciToggleSwitchComponent = class DavinciToggleSwitchComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['change']);
    }
};
DavinciToggleSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleSwitchComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciToggleSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciToggleSwitchComponent, isStandalone: true, selector: "davinci-toggle-switch", inputs: { checked: "checked", disabled: "disabled", tabindex: "tabindex", value: "value", name: "name", iconOn: "iconOn", iconOff: "iconOff", iconOnSrc: "iconOnSrc", iconOffSrc: "iconOffSrc" }, outputs: { change: "change" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciToggleSwitchComponent = __decorate([
    ProxyCmp({
        inputs: [
            'checked',
            'disabled',
            'tabindex',
            'value',
            'name',
            'iconOn',
            'iconOff',
            'iconOnSrc',
            'iconOffSrc',
        ],
    })
], DavinciToggleSwitchComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleSwitchComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-toggle-switch',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: [
                        'checked',
                        'disabled',
                        'tabindex',
                        'value',
                        'name',
                        'iconOn',
                        'iconOff',
                        'iconOnSrc',
                        'iconOffSrc',
                    ],
                    outputs: ['change'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciToggleSwitchComponent as a standalone component instead */
class DavinciToggleSwitchModule {
}
DavinciToggleSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciToggleSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleSwitchModule, imports: [DavinciToggleSwitchComponent], exports: [DavinciToggleSwitchComponent] });
DavinciToggleSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleSwitchModule, imports: [DavinciToggleSwitchComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciToggleSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciToggleSwitchComponent],
                    exports: [DavinciToggleSwitchComponent],
                }]
        }] });

/**
 * A `davinci-value-display` displays text.
 * It can be used to show a value with its unit.
 */
let DavinciValueDisplayComponent = class DavinciValueDisplayComponent {
    constructor(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
};
DavinciValueDisplayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciValueDisplayComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
DavinciValueDisplayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.12", type: DavinciValueDisplayComponent, isStandalone: true, selector: "davinci-value-display", inputs: { value: "value", unit: "unit", label: "label" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
DavinciValueDisplayComponent = __decorate([
    ProxyCmp({ inputs: ['value', 'unit', 'label'] })
], DavinciValueDisplayComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciValueDisplayComponent, decorators: [{
            type: Component,
            args: [{
                    standalone: true,
                    selector: 'davinci-value-display',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: '<ng-content></ng-content>',
                    inputs: ['value', 'unit', 'label'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.NgZone }]; } });
/** @deprecated import DavinciValueDisplayComponent as a standalone component instead */
class DavinciValueDisplayModule {
}
DavinciValueDisplayModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciValueDisplayModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DavinciValueDisplayModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: DavinciValueDisplayModule, imports: [DavinciValueDisplayComponent], exports: [DavinciValueDisplayComponent] });
DavinciValueDisplayModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciValueDisplayModule, imports: [DavinciValueDisplayComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: DavinciValueDisplayModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DavinciValueDisplayComponent],
                    exports: [DavinciValueDisplayComponent],
                }]
        }] });

/*
 * Public API Surface of @sick-ng/davinci-basic-elements
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DavinciAutoSuggestComponent, DavinciAutoSuggestModule, DavinciBalloonComponent, DavinciBalloonModule, DavinciBreadcrumbComponent, DavinciBreadcrumbItemComponent, DavinciBreadcrumbItemModule, DavinciBreadcrumbModule, DavinciButtonComponent, DavinciButtonModule, DavinciCalloutComponent, DavinciCalloutModule, DavinciCheckboxComponent, DavinciCheckboxModule, DavinciCollapseComponent, DavinciCollapseModule, DavinciDnDFileChooserComponent, DavinciDnDFileChooserModule, DavinciDropDownComponent, DavinciDropDownModule, DavinciFileChooserComponent, DavinciFileChooserModule, DavinciFlexiSliderComponent, DavinciFlexiSliderModule, DavinciFlyoutMenuComponent, DavinciFlyoutMenuItemComponent, DavinciFlyoutMenuItemModule, DavinciFlyoutMenuModule, DavinciIconComponent, DavinciIconModule, DavinciIconRefComponent, DavinciIconRefModule, DavinciLinkComponent, DavinciLinkModule, DavinciMultiSelectComponent, DavinciMultiSelectModule, DavinciNumberInputComponent, DavinciNumberInputModule, DavinciNumericFieldComponent, DavinciNumericFieldModule, DavinciOptionComponent, DavinciOptionGroupComponent, DavinciOptionGroupModule, DavinciOptionModule, DavinciPopupListComponent, DavinciPopupListModule, DavinciProgressLineComponent, DavinciProgressLineModule, DavinciRadioButtonComponent, DavinciRadioButtonModule, DavinciRangeSliderComponent, DavinciRangeSliderModule, DavinciSearchFieldComponent, DavinciSearchFieldModule, DavinciSliderComponent, DavinciSliderModule, DavinciSpinnerComponent, DavinciSpinnerModule, DavinciStatusIndicatorComponent, DavinciStatusIndicatorModule, DavinciStatusLineComponent, DavinciStatusLineModule, DavinciStatusTextComponent, DavinciStatusTextModule, DavinciTabComponent, DavinciTabModule, DavinciTabsComponent, DavinciTabsModule, DavinciTagComponent, DavinciTagModule, DavinciTagModuleComponent, DavinciTagModuleModule, DavinciTextAreaComponent, DavinciTextAreaModule, DavinciTextFieldComponent, DavinciTextFieldModule, DavinciTileComponent, DavinciTileModule, DavinciToggleGroupComponent, DavinciToggleGroupModule, DavinciToggleSwitchComponent, DavinciToggleSwitchModule, DavinciValueDisplayComponent, DavinciValueDisplayModule };
